import React from "react";

const DownloadMultiple = props => {
  let cloudColorFills;

  switch (props.variant) {
    case "blue":
      cloudColorFills = {
        top: "#C9DEF6",
        middle: "#81B3EE",
        bottom: "#017CC1"
      };
      break;
    default:
      cloudColorFills = {
        top: "#C7C7C7",
        middle: "#ADADAD",
        bottom: "#838383"
      };
      break;
  }
  return (
    <svg width="31" height="22" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M13 8h24v24H13z" />
        <path
          fill={cloudColorFills.top}
          fillRule="nonzero"
          d="M26.35 12.04a7.49 7.49 0 0 0-14-2A6 6 0 0 0 13 22h13a4.98 4.98 0 1 0 .35-9.96z"
        />
        <path d="M3-1h24v24H3z" />
        <path
          fill={cloudColorFills.middle}
          fillRule="nonzero"
          d="M22.35 9.04a7.49 7.49 0 0 0-14-2A6 6 0 0 0 9 19h13a4.98 4.98 0 1 0 .35-9.96z"
        />
        <path d="M0-4h24v24H0z" />
        <path
          fill={cloudColorFills.bottom}
          fillRule="nonzero"
          d="M19.35 6.04a7.49 7.49 0 0 0-14-2A6 6 0 0 0 6 16h13a4.98 4.98 0 1 0 .35-9.96z"
        />
        <path
          stroke="#FFF"
          strokeLinecap="square"
          strokeWidth="3"
          d="M12 11V6"
        />
        <path fill="#FFF" d="M12 14l5-5H7z" />
      </g>
    </svg>
  );
};

export default DownloadMultiple;
